__turbopack_context__.v({
  "inner": "jQVYPW_inner",
  "label": "jQVYPW_label",
  "root": "jQVYPW_root",
});
